module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/water_1b4416.jpg";